import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const Button = styled(PrimaryButton)`
  font-size: 12px !important;
  padding: 0.5rem 1rem;
`;

export const ContainerForm = styled.div`
  margin-top: 1rem;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  border-radius: 8px;
`;

export const ContainerInstrucoes = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.neutral.neutral70};
  margin-bottom: 0.5rem;
`;

export const PagamentoUrgenteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: 2.2rem;
  font-size: 0.9rem;

  .form-check-inline {
    margin-right: 0;
  }
`;

export const ValorInputWrapper = styled.div`
  position: relative;
`;

export const AvisoSemRecibo = styled.div`
  background-color: #fe8f14;
  color: #fff;
  font-weight: 600;
  font-size: 0.85rem;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AlertaValorIcone = styled.span`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: #fe8f14;
  font-size: 1rem;
  z-index: 5;
`;

export const BoletoListaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
`;

export const BoletoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 0.85rem;
  gap: 8px;
`;

export const BoletoNome = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const BoletoRemover = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.project.main};
  flex-shrink: 0;
`;
